import messages from '../../../messages/en.json';

export const appRoutes = {
  customerServicePhone: {
    path: messages.contact_phone_link
  },
  customerServiceMail: {
    path: 'mailto:atencionalcliente@citibox.com'
  },
  dropoff: {
    path: '/couriers/dropoffs'
  },
  dropoffCarrier: {
    path: '/couriers/dropoffs/:carrierSlug'
  },
  dropoffBox: {
    path: '/couriers/dropoffs/box',
    preventGoBack: true
  },
  dropoffBoxBle: {
    path: '/couriers/dropoffs/box/ble',
    preventGoBack: true
  },
  dropoffBoxKeypad: {
    path: '/couriers/dropoffs/box/keypad',
    preventGoBack: true
  },
  dropoffError: {
    path: '/couriers/dropoffs/error',
    preventGoBack: true
  },
  dropoffLocationIdentification: {
    path: '/couriers/dropoffs/location/identification',
    preventGoBack: true
  },
  dropoffSuccess: {
    path: '/couriers/dropoffs/success',
    preventGoBack: true
  },
  autofixRetryWrongCode: {
    path: '/autofix/retry/wrong-code',
    preventGoBack: true
  },
  autofixRetryReopen: {
    path: '/autofix/retry/reopen',
    preventGoBack: true
  },
  autofixRetryBoxSize: {
    path: '/autofix/retry/box-size',
    preventGoBack: true
  },
  autofixRetryDamagedBox: {
    path: '/autofix/retry/damaged-box',
    preventGoBack: true
  },
  couriersRetrievalsBox: {
    path: '/couriers/retrievals/box',
    preventGoBack: true
  },
  retrievalSuccess: {
    path: '/couriers/retrievals/success',
    preventGoBack: true
  },
  retrievalError: {
    path: '/couriers/retrievals/error',
    preventGoBack: true
  },
  retrievalLocationIdentification: {
    path: '/couriers/retrievals/location/identification',
    preventGoBack: true
  },
  pickupBox: {
    path: '/pickup/box',
    preventGoBack: true
  },
  pickupBoxBle: {
    path: '/pickup/ble/box',
    preventGoBack: true
  },
  pickupSuccess: {
    path: '/pickup/success',
    preventGoBack: true
  },
  retrievalBoxBle: {
    path: '/retrieval/ble/box',
    preventGoBack: true
  },
  retrievalBox: {
    path: '/retrieval/box'
  },
  usersPickupsSignupEmail: {
    path: '/users/pickups/signup/email'
  },
  usersPickupsSignupPassword: {
    path: '/users/pickups/signup/password'
  },
  usersPickupsSignupPersonalData: {
    path: '/users/pickups/signup/personal-data'
  },
  usersPickupsSignupWelcome: {
    path: '/users/pickups/signup/welcome'
  },
  usersPickupsAccountRemovalSuccess: {
    path: '/users/pickups/account-removal/success',
    preventGoBack: true
  },
  usersPickupsAccountRemovalWarning: {
    path: '/users/pickups/account-removal/warning'
  },
  usersPickupsAccountRemovalConfirm: {
    path: '/users/pickups/account-removal/confirm'
  },
  usersPickupsCompanyTracking: {
    path: '/users/pickups/:company/tracking'
  },
  usersPickupsCompanyBox: {
    path: '/users/pickups/:company/box'
  },
  iosDownload: {
    path: 'https://apps.apple.com/es/app/citibox-recibe-tus-paquetes/id1067653444'
  },
  androidDownload: {
    path: 'https://play.google.com/store/apps/details?id=com.citibox.android&hl=es'
  }
};
